import styled from 'styled-components';
import { mediaQueryDown, mediaQueryEqualOrUpper } from 'utils/mediaQueries';
export const StyledGrid = styled.div`
  display: flex;
  flex-direction: column;
  ${mediaQueryEqualOrUpper('xl')`
  display: grid;
  grid-template-rows: repeat(11, auto);
  column-gap: var(--spacer-5);
  row-gap: var(--spacer-2);

  &.two-columns {
      grid-template-columns: 1fr 1fr;

      .grid-popular-item,
      .grid-popular-header {
        grid-column-start: 2;
        grid-column-end: 2;
      }
    }

  &.single-column {
    grid-template-columns: 1fr;

    .grid-popular-item,
    .grid-popular-header {
      grid-column-start: 1;
      grid-column-end: 1;
    }
  }

  .grid-popular-header,
  .grid-recommended-header {
    grid-row-start: 1;
    grid-row-end: 1;
  }

  .grid-recommended-header,
  .grid-recommended-item {
    grid-column-start: 1;
    grid-column-end: 1;
  }
`}
`;

export const StyledCell = styled.div<{ $rowIndex: number }>`
  grid-row-start: ${props => `${props.$rowIndex + 2}`};
  grid-row-end: ${props => `${props.$rowIndex + 2}`};
  ${mediaQueryDown('xl')`
    padding-top: var(--spacer-2);
  `}
`;

export const StyledHeader = styled.h3`
  ${mediaQueryDown('xl')`
    margin-top: var(--spacer-4);
  `}
`;
